<script setup lang="ts">
import { showConfirmationDialog } from '#layers/ui/public';

import PdfPreviewPasswordInputDialog from './PdfPreviewPasswordInputDialog.vue';

defineProps<{
	passwordWrong?: boolean;
}>();

const emit = defineEmits<{
	unlock: [password: string];
}>();

async function handleUnlock() {
	const password = await showConfirmationDialog({
		component: PdfPreviewPasswordInputDialog,
	});

	if (password !== false) {
		emit('unlock', password as string);
	}
}

const customize = (content: string) => {
	return content
		.replaceAll(/stroke-width="[^"]*"/g, '');
};
</script>

<template>
	<div class="flex size-full min-h-64 flex-col items-center justify-center gap-4">
		<DIcon name="lucide:file-lock" size="96" class="stroke-[0.5] text-(--ui-border-accented)" mode="svg" :customize />
		<p class="max-w-xs text-center text-xs text-dimmed">
			{{ $t('file_preview.pdf.file_password_protected') }}
		</p>

		<div class="flex flex-col items-center gap-2">
			<DButton variant="outline" color="neutral" icon="lucide:unlock" size="sm" @click="handleUnlock">
				{{ $t('file_preview.pdf.file_unlock') }}
			</DButton>
			<p v-if="passwordWrong" class="max-w-xs text-center text-xs text-error">
				{{ $t('file_preview.pdf.file_password_wrong') }}
			</p>
		</div>
	</div>
</template>
